(function () {
    function formatBytes(bytes) {
        if (!Number.isFinite(bytes) || bytes < 1) {
            return '0 B';
        }
        if (bytes < 1024) {
            return bytes + ' B';
        }
        if (bytes < 1024 * 1024) {
            return (bytes / 1024).toFixed(1).replace(/\.0$/, '') + ' KB';
        }
        return (bytes / (1024 * 1024)).toFixed(1).replace(/\.0$/, '') + ' MB';
    }

    function renderFileList(input) {
        var target = document.querySelector(input.getAttribute('data-collab-file-list') || '');
        if (!target) {
            return;
        }

        target.innerHTML = '';
        Array.prototype.forEach.call(input.files || [], function (file, index) {
            var item = document.createElement('div');
            item.className = 'list-group-item d-flex justify-content-between align-items-center gap-2 px-0';
            item.innerHTML = '<span class="text-truncate">' + file.name + '</span><span class="text-muted text-nowrap">' + formatBytes(file.size) + '</span>';

            if (window.DataTransfer) {
                var remove = document.createElement('button');
                remove.type = 'button';
                remove.className = 'btn btn-sm btn-link text-danger p-0';
                remove.setAttribute('aria-label', 'Remove ' + file.name);
                remove.innerHTML = '<i class="bi bi-x-lg" aria-hidden="true"></i>';
                remove.addEventListener('click', function () {
                    var transfer = new DataTransfer();
                    Array.prototype.forEach.call(input.files || [], function (candidate, candidateIndex) {
                        if (candidateIndex !== index) {
                            transfer.items.add(candidate);
                        }
                    });
                    input.files = transfer.files;
                    renderFileList(input);
                });
                item.appendChild(remove);
            }

            target.appendChild(item);
        });
    }

    function updateNoteCount(input) {
        var target = document.querySelector(input.getAttribute('data-collab-note-count') || '');
        if (target) {
            target.textContent = String(input.value.length);
        }
    }

    function filenameFromDisposition(disposition, fallback) {
        if (!disposition) {
            return fallback;
        }
        var utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
        if (utf8Match && utf8Match[1]) {
            try {
                return decodeURIComponent(utf8Match[1].replace(/"/g, ''));
            } catch (e) {
                return utf8Match[1].replace(/"/g, '');
            }
        }
        var plainMatch = disposition.match(/filename="?([^";]+)"?/i);
        return plainMatch && plainMatch[1] ? plainMatch[1] : fallback;
    }

    function triggerBlobDownload(blob, filename) {
        var objectUrl = URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = objectUrl;
        link.download = filename || 'download';
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.setTimeout(function () {
            URL.revokeObjectURL(objectUrl);
        }, 1000);
    }

    function showDownloadError(button, message) {
        var target = button.closest('.card') || document.body;
        var alert = document.createElement('div');
        alert.className = 'alert alert-danger mt-2';
        alert.textContent = message || 'The download could not be completed.';
        target.prepend(alert);
    }

    function escapeHtml(value) {
        return String(value || '').replace(/[&<>"']/g, function (char) {
            return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' })[char];
        });
    }

    function manifestOptionHtml(manifest) {
        return '<span><span class="fw-semibold">' + escapeHtml(manifest.manifest_no) + '</span><span class="d-block text-muted small">' + escapeHtml(manifest.created_at || '') + ' by ' + escapeHtml(manifest.creator_name || '') + '</span></span><span class="text-muted small text-nowrap">' + Number(manifest.linked_waybill_count || 0) + ' Waybill' + (Number(manifest.linked_waybill_count || 0) === 1 ? '' : 's') + '</span>';
    }

    function renderManifestList(target, manifests) {
        if (!target) {
            return;
        }
        if (!Array.isArray(manifests) || manifests.length === 0) {
            target.innerHTML = '<div class="list-group-item text-muted">No Manifests have been created for this Workflow.</div>';
            return;
        }
        target.innerHTML = manifests.map(function (manifest) {
            return '<div class="list-group-item d-flex justify-content-between gap-3"><div><div class="fw-semibold">' + escapeHtml(manifest.manifest_no) + '</div><div class="text-muted">' + escapeHtml(manifest.created_at || '') + ' by ' + escapeHtml(manifest.creator_name || '') + '</div></div><span class="text-muted text-nowrap">' + Number(manifest.linked_waybill_count || 0) + ' Waybill' + (Number(manifest.linked_waybill_count || 0) === 1 ? '' : 's') + '</span></div>';
        }).join('');
    }

    function setupManifestAutocomplete(root) {
        var input = root.querySelector('[data-collab-manifest-input]');
        var hidden = root.querySelector('[data-collab-manifest-id]');
        var results = root.querySelector('[data-collab-manifest-results]');
        var workflow = root.getAttribute('data-workflow') || 'BW';
        var displayOnly = root.getAttribute('data-display-only') === '1';
        var selectedText = input ? input.value : '';
        var requestId = 0;
        var timer = null;

        if (!input || !results) {
            return;
        }

        function showMessage(message) {
            results.innerHTML = '<div class="text-muted small p-2">' + escapeHtml(message) + '</div>';
            results.classList.remove('d-none');
        }

        function clearResults() {
            results.classList.add('d-none');
            results.innerHTML = '';
        }

        function search() {
            var query = input.value.trim();
            requestId += 1;
            var currentRequest = requestId;
            if (hidden && query !== selectedText) {
                hidden.value = '';
                hidden.dispatchEvent(
                    new Event('change', { bubbles: true })
                );
            }
            if (query.length < 4) {
                showMessage('Type at least 4 characters');
                return;
            }
            showMessage('Loading...');
            fetch('/customs/collaboration/manifests/autocomplete?workflow=' + encodeURIComponent(workflow) + '&q=' + encodeURIComponent(query), {
                method: 'GET',
                credentials: 'same-origin',
                headers: { 'X-Requested-With': 'XMLHttpRequest' }
            }).then(function (response) {
                if (!response.ok) {
                    throw new Error('Unable to load Manifests.');
                }
                return response.json();
            }).then(function (payload) {
                if (currentRequest !== requestId) {
                    return;
                }
                var manifests = Array.isArray(payload.manifests) ? payload.manifests : [];
                if (manifests.length === 0) {
                    showMessage('No matching Manifests');
                    return;
                }
                results.innerHTML = manifests.slice(0, 15).map(function (manifest) {
                    return '<button type="button" class="collab-autocomplete-option" data-id="' + Number(manifest.id || 0) + '" data-label="' + escapeHtml(manifest.manifest_no) + '">' + manifestOptionHtml(manifest) + '</button>';
                }).join('');
                results.classList.remove('d-none');
            }).catch(function () {
                if (currentRequest === requestId) {
                    showMessage('Unable to load Manifests.');
                }
            });
        }

        input.addEventListener('input', function () {
            window.clearTimeout(timer);
            timer = window.setTimeout(search, 300);
        });
        input.addEventListener('focus', function () {
            if (input.value.trim().length > 0) {
                search();
            }
        });
        input.addEventListener('keydown', function (event) {
            var options = Array.prototype.slice.call(results.querySelectorAll('.collab-autocomplete-option'));
            var current = document.activeElement;
            if (event.key === 'ArrowDown' && options.length > 0) {
                event.preventDefault();
                (options[options.indexOf(current) + 1] || options[0]).focus();
            }
            if (event.key === 'ArrowUp' && options.length > 0) {
                event.preventDefault();
                (options[options.indexOf(current) - 1] || options[options.length - 1]).focus();
            }
            if (event.key === 'Escape') {
                clearResults();
            }
        });
        results.addEventListener('click', function (event) {
            var option = event.target.closest('.collab-autocomplete-option');

            if (!option) {
                return;
            }

            selectedText = option.getAttribute('data-label') || '';
            input.value = selectedText;

            if (hidden && !displayOnly) {
                hidden.value = option.getAttribute('data-id') || '';

                hidden.dispatchEvent(
                    new Event('change', { bubbles: true })
                );
            }

            clearResults();

            /*
             * Do not refocus the input here.
             * Refocusing triggers the focus handler and reopens the results.
             */
            input.blur();
        });
        document.addEventListener('click', function (event) {
            if (!root.contains(event.target)) {
                clearResults();
            }
        });
    }

    function renderStatistics(target, statistics) {
        if (!target) {
            return;
        }
        if (!statistics || !Array.isArray(statistics.status_counts) || !Array.isArray(statistics.daily)) {
            target.innerHTML = '<div class="alert alert-danger mb-0">Malformed statistics response.</div>';
            return;
        }
        if (Number(statistics.total || 0) === 0) {
            target.innerHTML = '<div class="alert alert-info mb-0">No Workflow entries match the current filters.</div>';
            return;
        }
        var summary = statistics.status_counts.map(function (item) {
            return '<div class="col"><div class="border rounded p-2 h-100"><div class="text-muted small">' + escapeHtml(item.label) + '</div><div class="fs-5 fw-semibold">' + Number(item.count || 0) + '</div></div></div>';
        }).join('');
        var headers = statistics.status_counts.map(function (item) {
            return '<th class="text-end">' + escapeHtml(item.label) + '</th>';
        }).join('');
        var rows = statistics.daily.map(function (row) {
            var cells = statistics.status_counts.map(function (item) {
                return '<td class="text-end">' + Number((row.status_counts || {})[item.key] || 0) + '</td>';
            }).join('');
            return '<tr><td class="text-nowrap">' + escapeHtml(row.date) + '</td><td class="text-end fw-semibold">' + Number(row.total || 0) + '</td>' + cells + '</tr>';
        }).join('');
        target.innerHTML = '<div class="mb-3"><div class="text-muted small">Total matching entries</div><div class="display-6">' + Number(statistics.total || 0) + '</div></div><div class="row row-cols-2 row-cols-md-5 g-2 mb-3">' + summary + '</div><div class="text-muted small mb-2">' + escapeHtml(statistics.note || '') + '</div><div class="table-responsive"><table class="table table-sm align-middle collab-stat-table"><thead><tr><th>Date</th><th class="text-end">Total</th>' + headers + '</tr></thead><tbody>' + rows + '</tbody></table></div>';
    }

    document.addEventListener('submit', function (event) {
        var form = event.target.closest('[data-collab-manifest-create-form]');
        if (!form) {
            return;
        }
        event.preventDefault();
        var error = form.querySelector('[data-collab-manifest-create-error]');
        var success = form.querySelector('[data-collab-manifest-create-success]');
        var submitter = form.querySelector('[type="submit"]');
        if (error) {
            error.classList.add('d-none');
            error.textContent = '';
        }
        if (success) {
            success.classList.add('d-none');
            success.textContent = '';
        }
        if (submitter) {
            submitter.disabled = true;
        }
        fetch(form.action, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            body: new FormData(form)
        }).then(function (response) {
            return response.json().then(function (payload) {
                if (!response.ok) {
                    throw payload;
                }
                return payload;
            });
        }).then(function (payload) {
            if (success) {
                success.textContent = payload.message || 'Manifest created successfully.';
                success.classList.remove('d-none');
            }
            form.querySelector('[name="manifest_no"]').value = '';
            renderManifestList(document.querySelector('[data-collab-recent-manifests]'), payload.manifests || []);
        }).catch(function (payload) {
            if (error) {
                error.textContent = payload && payload.message ? payload.message : 'Unable to create Manifest.';
                error.classList.remove('d-none');
            }
        }).finally(function () {
            if (submitter) {
                submitter.disabled = false;
            }
        });
    });

    document.addEventListener('change', function (event) {
        if (event.target.matches('[data-collab-file-input]')) {
            renderFileList(event.target);
        }
    });

    document.addEventListener('input', function (event) {
        if (event.target.matches('[data-collab-note-input]')) {
            updateNoteCount(event.target);
        }
    });

    document.addEventListener('submit', function (event) {
        var form = event.target.closest('[data-collab-busy-form]');
        if (!form) {
            return;
        }
        if (form.dataset.collabSubmitting === '1') {
            event.preventDefault();
            return;
        }

        form.dataset.collabSubmitting = '1';
        var submitter = event.submitter || form.querySelector('[type="submit"]');
        if (submitter) {
            var busyText = submitter.getAttribute('data-collab-busy-text') || 'Working...';
            submitter.disabled = true;
            submitter.innerHTML = '<span class="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>' + busyText;
        }
    });

    document.querySelectorAll('[data-collab-manifest-autocomplete]').forEach(setupManifestAutocomplete);

    document.addEventListener('shown.bs.modal', function (event) {
        if (!event.target.matches('#workflowStatisticsModal')) {
            return;
        }
        var body = event.target.querySelector('[data-collab-statistics-body]');
        if (!body) {
            return;
        }
        body.innerHTML = '<div class="text-muted">Loading statistics...</div>';
        fetch('/customs/collaboration/statistics?' + window.location.search.replace(/^\?/, ''), {
            method: 'GET',
            credentials: 'same-origin',
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
        }).then(function (response) {
            if (!response.ok) {
                throw new Error('Unable to load statistics.');
            }
            return response.json();
        }).then(function (payload) {
            renderStatistics(body, payload.statistics);
        }).catch(function (error) {
            body.innerHTML = '<div class="alert alert-danger mb-0">' + escapeHtml(error && error.message ? error.message : 'Unable to load statistics.') + '</div>';
        });
    });

    document.addEventListener('click', function (event) {
        var button = event.target.closest('[data-collab-download]');
        if (!button) {
            return;
        }
        event.preventDefault();
        if (button.classList.contains('disabled') || button.dataset.collabDownloading === '1') {
            return;
        }

        button.dataset.collabDownloading = '1';
        var originalHtml = button.innerHTML;
        button.classList.add('disabled');
        button.innerHTML = '<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>';

        fetch(button.href, {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        }).then(function (response) {
            if (!response.ok) {
                throw new Error('The download could not be completed.');
            }
            var filename = filenameFromDisposition(response.headers.get('Content-Disposition'), button.getAttribute('download') || 'download');
            return response.blob().then(function (blob) {
                triggerBlobDownload(blob, filename);
            });
        }).then(function () {
            window.location.reload();
        }).catch(function (error) {
            button.dataset.collabDownloading = '0';
            button.classList.remove('disabled');
            button.innerHTML = originalHtml;
            showDownloadError(button, error && error.message ? error.message : 'The download could not be completed.');
        });
    });

    document.addEventListener('shown.bs.modal', function (event) {
        var focusable = event.target.querySelector('[autofocus], textarea, input:not([type="hidden"])');
        if (focusable) {
            focusable.focus();
        }
        var noteInput = event.target.querySelector('[data-collab-note-input]');
        if (noteInput) {
            updateNoteCount(noteInput);
        }
    });
}());
